import get from 'lodash/get'
import DirectDepositCard from '../cards/DirectDepositCard'
import PhysicalCard from '../cards/PhysicalCard'
import VirtualECard from '../cards/VirtualECard'

// Stripe Status Enum
const StripeStatus = Object.freeze({
  ACTIVE: 'active',
  INACTIVE: 'inactive',
})

const PAYMENT_PLACEHOLDER_MARK = 'PLACEHOLDER'

export default {
  methods: {
    getCardComponent(paymentAccount) {
      switch (paymentAccount.vendor_product) {
        case 'Connect':
          return DirectDepositCard
        case 'Issuing':
          if (paymentAccount.entity_payment.meta.card_type === 'physical') {
            return PhysicalCard
          } else {
            return VirtualECard
          }
      }
    },
    getCardProps(paymentAccount) {
      switch (paymentAccount.vendor_product) {
        case 'Connect':
          return {
            cardholderName: this.getCardholderName(paymentAccount),
            accountNumber: this.getAccountNumber(paymentAccount),
          }
        case 'Issuing':
          return {
            cardholderName: this.getCardholderName(paymentAccount),
            cardNumber: this.getCardNumber(paymentAccount),
            expirationDate: this.getExpirationDate(paymentAccount),
            pending: this.isCardIssuingPending(paymentAccount),
          }
      }
    },
    getPaymentAccountStatus(paymentAccount) {
      const entityPaymentStatus = get(paymentAccount, [
        'entity_payment',
        'status',
      ])
      const entityPaymentValue = get(paymentAccount, [
        'entity_payment',
        'value',
      ])
      const stripeStatus = get(paymentAccount, ['stripe_api_obj', 'status'])

      if (
        entityPaymentValue &&
        entityPaymentValue.includes(PAYMENT_PLACEHOLDER_MARK)
      ) {
        return -1
      }

      if (stripeStatus === StripeStatus.INACTIVE) {
        return -1
      }

      return entityPaymentStatus
    },
    isCardIssuingPending(paymentAccount) {
      return this.getPaymentAccountStatus(paymentAccount) !== 1
    },
    getAccountNumber(paymentAccount) {
      const accountNumber = paymentAccount.stripe_api_obj.last4 || 'XXXX'
      return this.$t('ppm_modal__success_message1', { accountNumber })
    },
    getCardholderName(paymentAccount) {
      switch (paymentAccount.vendor_product) {
        case 'Connect':
          return (
            paymentAccount.stripe_api_obj.account_holder_name ||
            'YOUR NAME HERE'
          )
        default:
          return (
            paymentAccount.stripe_api_obj.cardholder?.name || 'YOUR NAME HERE'
          )
      }
    },
    getCardNumber(paymentAccount) {
      const cardNumber = paymentAccount.stripe_api_obj.number || 'XXXX'
      return `●●●● ${cardNumber.substring(cardNumber.length - 4)}`
    },
    getExpirationDate(paymentAccount) {
      const month = paymentAccount.stripe_api_obj.exp_month || 'MM'
      const year = paymentAccount.stripe_api_obj.exp_year || 'YY'
      const formattedMonth = `${month}`.padStart(2, '0')
      const formattedYear = `${year}`.substring(`${year}`.length - 2)
      return `Exp. ${formattedMonth}/${formattedYear}`
    },
    getHumanizeCardType(paymentAccount) {
      const humanizedCardTypes = {
        physical: this.$t('payment_methods.physical_card'),
        virtual: this.$t('payment_methods.virtual_ecard'),
      }
      const cardType = get(paymentAccount, [
        'entity_payment',
        'meta',
        'card_type',
      ])

      return humanizedCardTypes[cardType]
    },
    getAccountType(paymentAccount) {
      switch (paymentAccount.vendor_product) {
        case 'Connect':
          return this.$t('payment_methods.direct_deposit')
        case 'Issuing':
          return this.getHumanizeCardType(paymentAccount)
      }
    },
    getCardSuccessMessage(paymentAccount) {
      switch (paymentAccount.vendor_product) {
        case 'Connect':
          return this.getAccountNumber(paymentAccount)
        case 'Issuing':
          return this.$t('ppm_modal__success_message2')
      }
    },
  },
}
